/*
* @Description: ""
* @Author: YOYO 792611446@qq.com
 * @LastEditors: ChangWenBo (649160016@qq.com)
* @Date:   2019-04-18 17:25:40
 * @LastEditTime: 2021-04-02 15:38:41
*/
import request from '@/utils/request'
// import { getServiceCode } from '@/cont.js'
// const areaCode = getServiceCode(process.env.VUE_APP_REGIONAL)
// 客户查询列表
const customerlistUrl = '/rest/base/customers/list'
// 产品查询列表
const productlistUrl = '/rest/base/products/list'
// 项目列表分页查询
const projectslistUrl = '/rest/base/projects/page'
// 新增客户管理
const projectssaveUrl = '/rest/base/projects/save'
// 根据字典类型查询字典列表
const listDictByTypeUrl = '/rest/base/dict/listDictByType'

/**
 * @description: 产品列表分页查询
 * @param        {object} params 请求接口参数：pageNo='页码'，pageSize='每页条数'
 * @return       {object} res
 */
export async function getProductslist (params) {
  return request.get(projectslistUrl, {
    ...params,
  })
}
/**
 * @description: 客户管理列表查询
 * @return       {object} res
 */
export async function getCustomlist () {
  return request.get(customerlistUrl)
}
/**
 * @description: 产品管理列表查询
 * @return       {object} res
 */
export async function getProductlist () {
  return request.get(productlistUrl)
}
/**
 * @description: 删除客户信息
 * @param        {object} params id='客户主键'
 * @return       {object} res
 */
export async function deleteProject (params) {
  return request.post(`/rest/base/projects/${params}/del`, {
    ...params,
  })
}

/**
 * @description: 保存客户信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function saveProject (params) {
  return request.post(projectssaveUrl, {
    ...params,
  }, {}, 2)
}
/**
 * @description: 客户管理列表分页查询
 * @param        {object} params 请求接口参数：type='字典类型'
 * @return       {object} res
 */
export async function getlistDictByType (params) {
  return request.get(listDictByTypeUrl, {
    ...params,
  })
}
/**
 * @description: 项目详情
 * @param        {object} params id='项目'
 * @return       {object} res
 */
export async function projectDetail (params) {
  return request.get(`/rest/base/projects/${params}/detail`, {
    ...params,
  })
}
/**
 * @description: 更新客户信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function updateProject (params) {
  console.log(params)
  return request.post(`/rest/base/projects/${params.id}/update`, {
    ...params,
  }, {}, 2)
}
